import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as ContactActions from 'web-app/react/entities/contacts/actions';

import * as Actions from './actions';

const ChildContacts = Record({
    didFetchData: false,
    updating: false,
    passive: true,
    selectedRelationId: undefined,
    selectedIndex: undefined,
});

const childContacts = handleActions(
    {
        [Actions.fetch.type]: state => state.merge({updating: true, didFetchData: false}),
        [Actions.fetchSuccess.type]: state =>
            state.merge({
                selectedRelationId: undefined,
                updating: false,
                didFetchData: true,
            }),
        [Actions.fetchFailed.type]: state => state.merge({updating: false}),
        [Actions.update.type]: state => state.merge({updating: true}),
        [Actions.updateSuccess.type]: state => state.merge({updating: false, passive: true}),
        [Actions.updateFailed.type]: state => state.merge({updating: false}),
        [Actions.changeSelectedChildContact.type]: (state, action) =>
            state.merge({
                passive: true,
                selectedRelationId: undefined,
                selectedIndex: action.payload,
            }),
        [Actions.edit.type]: state =>
            state.merge({
                passive: false,
            }),
        [Actions.cancel.type]: state =>
            state.merge({
                passive: true,
            }),
        [ContactActions.createChildContactSuccess.type]: (state, {payload}) =>
            state.merge({
                selectedRelationId: payload.contact.relationId,
                selectedIndex: undefined,
            }),
        [ContactActions.deleteChildContactSuccess.type]: state =>
            state.merge({
                selectedIndex: null,
                passive: true,
            }),
    },
    new ChildContacts(),
);

export default childContacts;
